import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { useForm } from '@uhg-abyss/web/hooks/useForm';

export const ByTrackingNumber = ({
  required,
  id,
  inputModel,
  inputLabel,
  ...props
}) => {
  const MIN_LENGTH = 8;

  const form = useForm();
  useEffect(() => {
    form.setValue(inputModel, '');
  }, []);

  return (
    <React.Fragment>
      <TextInput
        {...props}
        id={inputLabel}
        aria-label="type here to enter a reference number"
        label="Reference Number"
        maxLength={13}
        isClearable
        autoComplete="off"
        model={inputModel}
        validators={{
          required: 'Please enter a valid Reference Number.',
          validate: {
            isValidReference: (value) => {
              return (
                value.length >= MIN_LENGTH || 'Reference Number is invalid'
              );
            },
          },
        }}
        formatter={(value) => {
          return value.replace(/[!@#$%^&*)({}<>,.[\]\-+_`~=\\|';":/?]/g, '');
        }}
      />
    </React.Fragment>
  );
};

ByTrackingNumber.propTypes = {
  required: PropTypes.bool,
  inputModel: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
};

ByTrackingNumber.defaultProps = {
  required: false,
};
